import React from "react";
import TeamPageNav from "../../components/TeamPageNav/TeamPageNav";
import TeamMemberCard from "../../components/TeamMemberCard/TeamMemberCard";
import AlisonBrooks from "../../assets/team-members/alison-brooks.jpg";
import JackHill from "../../assets/team-members/jack-hill.jpg";
import KimberlyIvich from "../../assets/team-members/kimberly-ivich.jpg";
import AshleyLowe from "../../assets/team-members/ashley-lowe.jpg";
import RayaManship from "../../assets/team-members/raya-manship.jpg";
import BrandonMenasian from "../../assets/team-members/brandon-menasian.jpg";
import MeganStuff from "../../assets/team-members/megan-stuff.jpg";
import { siteLightBlue } from "../../providers/Theme";
import {
  PageSection,
  PageInner,
  PageHeading,
  PageSubtitle,
  MembersGrid,
  BackButton
} from "./styled.components";

interface Member {
  name: string;
  role: string;
  org: string;
  bio: string;
  photo?: string;
}

const members: Member[] = [
  {
    name: "Alison Brooks",
    role: "Community Partner",
    org: "VP, Marketing & Destination Experience, Visit Mesa",
    photo: AlisonBrooks,
    bio: "Alison is Vice President of Marketing and Destination Experience at Visit Mesa, where she leads strategic marketing, accessibility initiatives, and visitor experience. She is advancing Mesa's goal to become the first KRF-certified destination and serves on the Mesa for All board."
  },
  {
    name: "Jack Hill",
    role: "Healthcare Strategy Advisor",
    org: "Xolair Territory Manager, Genentech USA",
    photo: JackHill,
    bio: "Jack is a healthcare strategy leader with nearly 30 years in pharmaceutical, medical device, and biotech industries, specializing in allergic asthma and food allergy for the past 15 years. A former U.S. Air Force Intelligence Officer, he brings discipline and clinical partnership expertise to KRF's mission."
  },
  {
    name: "Kimberly Ivich, BSN, RN",
    role: "Public Health Nurse",
    org: "Outreach & Special Projects, Maricopa County Public Health",
    photo: KimberlyIvich,
    bio: "Kimberly is a Public Health Nurse Lead for Outreach and Special Projects with Maricopa County Public Health, Community Wellness and Health Promotion. A leading proponent of the School Stock Medication Program, she has spent years implementing and certifying this life-saving initiative across Arizona schools."
  },
  {
    name: "Ashley A. Lowe, PhD, MSPH",
    role: "Public Health Research Advisor",
    org: "Assistant Professor, University of Arizona College of Nursing",
    photo: AshleyLowe,
    bio: "Dr. Lowe is an Assistant Professor at the University of Arizona College of Nursing and Program Director of the Stock Inhaler for Schools Program. Over eight years, she has trained thousands of school nurses and staff to respond to emergencies, significantly reducing emergency transports for students."
  },
  {
    name: "Raya Manship, PharmD",
    role: "Pharmacy Advisor",
    org: "Specialty Pharmacist, Omniscript / Revelation Pharma Network",
    photo: RayaManship,
    bio: "Raya is a specialty and compounding pharmacist with Omniscript, part of the Revelation Pharma Network, and holds a Doctor of Pharmacy from the University of Kansas. Motivated by her son's life-threatening anaphylactic allergy, she is dedicated to raising awareness and empowering families to manage food allergy risk."
  },
  {
    name: "Brandon Menasian",
    role: "Culinary & Hospitality Advisor",
    org: "Executive Chef & Director, Hilton",
    photo: BrandonMenasian,
    bio: "Brandon is the Executive Chef and Director of Food & Beverage at the DoubleTree by Hilton Phoenix Mesa. Raised in Hawaii and based in Arizona since 2010, Brandon brings hospitality leadership and a personal understanding of severe food allergies to KRF's strategic team. He supports initiatives that advance food allergy education, awareness, and safer, more inclusive dining experiences."
  },
  {
    name: "Megan Stuff",
    role: "Healthcare Operations Advisor",
    org: "Chief Operating Officer, Southwest Medical Imaging",
    photo: MeganStuff,
    bio: "Megan is Chief Operating Officer at Southwest Medical Imaging and an MRI Safety Officer with over 20 years in diagnostic imaging. She holds a Master's in Organizational Leadership and serves on the American Heart Association's Go Red for Women Executive Leadership Team."
  }
];

const StrategicTeamPage: React.FC = () => (
  <>
    <TeamPageNav />
    <PageSection>
      <PageInner>
        <PageHeading $color={siteLightBlue}>Strategic Team</PageHeading>
        <PageSubtitle>
          Our strategic advisors bring depth in public health, policy,
          education, and community development to advance KRF's mission at every
          level.
        </PageSubtitle>
        <MembersGrid>
          {members.map(m => (
            <TeamMemberCard
              key={m.name}
              photo={m.photo}
              name={m.name}
              role={m.role}
              roleColor={siteLightBlue}
              subtitle={m.org}
              bio={m.bio}
            />
          ))}
        </MembersGrid>
        <BackButton
          to="/about-us/our-team"
          onClick={() => window.scrollTo(0, 0)}
        >
          Back to Our Team →
        </BackButton>
      </PageInner>
    </PageSection>
  </>
);

export default StrategicTeamPage;
